import type { ButtonProps } from '@ad-lucy/components/shared/Button/types';
import type { GlobalMeta } from '@ad-lucy/context/adData';
import type { Alignment, ParsedAlignment } from '@ad-lucy/utils/scaling/types';
import type { MouseEvent } from 'react';
import type { Direction, FlexAlign } from './SimpleNavigationArrow/utils/types';

export interface ArrowButtonProps extends ButtonProps {
  direction: Direction;
  color: string;
  colorHover: string;
  colorArrow: string;
  colorArrowHover: string;
  showOnHover?: boolean;
  isLegacyIOSVersion?: boolean;
  width?: string;
  topPosition?: string;
  topPosition_m?: string;
  topPosition_s?: string;
  horizontalPosition?: string;
  horizontalPosition_m?: string;
  horizontalPosition_s?: string;
  pulseAnimationOption?: GlobalMeta['navigationArrows_pulseAnimation'];
  containerWidth?: number;
  referenceWidth?: number;
  arrowPosition?: ParsedAlignment;
  svgAlignment?: Alignment;
  buttonAlignment?: FlexAlign;
}

export type StyledButtonProps = Pick<
  ArrowButtonProps,
  'direction' | 'width' | 'topPosition' | 'showOnHover'
> & {
  arrowLeft: number;
  arrowTop: number;
  iconLeft: number;
  iconRight: number;
  alignY: FlexAlign;
};

export interface ArrowButtonIconProps {
  colorArrow?: string;
  colorArrowHover?: string;
}

export interface NavigationArrowProps extends ArrowButtonProps {
  design?: Arrows;
  onClick?: (e: MouseEvent) => void;
  containerWidth?: number;
  referenceWidth?: number;
  enablePositionSettingsDifferentViewports?: boolean;
  enableWidthSettingsDifferentViewports?: boolean;
}

export enum Arrows {
  COLORED = 'colored',
  SIMPLE = 'simple',
  ROUNDED = 'rounded',
  NONE = 'none',
}
